import { PatientOrders } from '~/features/orders/PatientOrders';
import { Section } from '~/shared/section/Section';
import { SectionTitle } from '~/shared/section/SectionTitle';
import { useChart } from '~/features/admissions/charts/ChartContext';

export function PatientOrdersRoute() {
	const { stayId, certificationPeriodId } = useChart();
	return (
		<Section header={<SectionTitle title="Orders" />}>
			<PatientOrders stayId={stayId} certificationPeriodId={certificationPeriodId} />
		</Section>
	);
}
